import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import {
    AttorneyService,
    PortalConfigurationService,
} from "../../../../services/ClientService";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import { useCallback } from "react";
import CredentialsModal from "../../../queue/components/modals/CredentialsModal";

export default function ProfileConfigurations({
    attorney,
}: {
    attorney: APIModels.Attorney;
}) {
    const never = "never" as const;
    const [portalConfigurations, setPortalConfigurations] = useState(
        [] as APIModels.PortalConfigurationRequest[]
    );

    const [selectedId, setSelectedId] = useState("");

    const [modalShow, setModalShow] = useState(false);
    const refreshData = () => {
        if (attorney.id != "") {
            PortalConfigurationService.getList({
                attorneyId: attorney.id ?? "",
            }).then(
                (resp) => {
                    if (resp.successful === true) {
                        console.log("PortalConfiguration2 " + attorney.id);
                        setPortalConfigurations(
                            resp.data as APIModels.PortalConfigurationRequest[]
                        );
                    } else {
                        console.log("error");
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    useEffect(() => {
        PortalConfigurationService.getList({
            attorneyId: attorney.id ?? "",
        }).then(
            (resp) => {
                if (resp.successful === true) {
                    setPortalConfigurations(resp.data!);
                } else {
                    console.log("Error");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, [attorney]);

    const getRowId = (rowData: APIModels.PortalConfigurationRequest) => {
        setSelectedId(rowData.id!);
    };

    return (
        <div className="card text-center">
            <CredentialsModal
                show={modalShow}
                portalConfigId={selectedId}
                onClose={() => setModalShow(false)}
            />
            <div className="card-body">
                <div style={{ maxWidth: "100%", zIndex: -1 }}>
                    <MaterialTable
                        columns={[
                            {
                                title: "ID",
                                field: "id",
                                editable: never,
                            },
                            {
                                title: "State",
                                field: "state",
                            },
                            {
                                title: "Portal Identifier",
                                field: "portalIdentifier",
                            },
                            {
                                title: "Username",
                                field: "username",
                            },
                            {
                                title: "Password",
                                field: "password",
                            },
                            {
                                title: "PaymentToken",
                                field: "paymentToken",
                            },
                            {
                                title: "CVV",
                                field: "cvv",
                            },
                            {
                                title: "DisplayName",
                                field: "displayName",
                            },
                        ]}
                        data={portalConfigurations}
                        title="Portal Configurations"
                        actions={[
                            {
                                icon: "library_add",
                                tooltip: "Show UserName/Password",
                                onClick: (event, rowData) => {
                                    getRowId(
                                        rowData as APIModels.PortalConfigurationRequest
                                    ),
                                        setModalShow(true);
                                },
                            },
                        ]}
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve, reject) => {
                                    PortalConfigurationService.add({
                                        attorneyId: attorney.id ?? "",
                                        body: newData!,
                                    }).then(
                                        (resp) => {
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                            onRowUpdate: (newData, oldData) =>
                                new Promise((resolve, reject) => {
                                    PortalConfigurationService.update({
                                        portalConfigId: oldData?.id ?? "",
                                        body: newData!,
                                    }).then(
                                        (resp) => {
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                            onRowDelete: (oldData) =>
                                new Promise((resolve, reject) => {
                                    PortalConfigurationService.delete({
                                        id: oldData.id ?? "",
                                    }).then(
                                        (resp) => {
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
